import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <MediaSection />
        <AboutSection />
        <FaqSection />
        <IndexSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <ContactSection />
        <CarouselSection />
        <FeaturesSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}